<template>
  <div>
    <span @click="modal = true">
      <slot></slot>
    </span>

      <transition name="fade">
        <div v-if="modal" class="dialog">
          <div class="dialog-wrapper">
            <div class="dialog-header"></div>
            <div class="dialog-body p-4">
              <p class="text-dark">
              مطمئنید میخواهید خارج شوید ؟
              </p>
            </div>
            <div class="dialog-footer">
              <button @click="Logout" class="ar-btn size-sm danger">خروج</button>
              <button @click="modal = false" class="ar-btn size-sm outline-primary mx-3">انصراف</button>
            </div>
          </div>
        </div>
      </transition>

  </div>
</template>
<script>
export default {
  name: 'LogoutBtn',
  components:{
  },
  props:{
    dashboardBtn: {
      type: String,
      required: false
    },
    headerBtn: {
      type: String,
      required: false
    },
    btntext:{
      type: String,
      default : 'خروج از حساب کاربری'
    },
    icon:{
      type: Boolean,
      default : false
    },
    underline:{
      type: Boolean,
      default : false
    }
  },
  data : () => ({
    modal:false
  }),
  watch:{
    
  },
  methods:{
    Logout(){
      this.UserLogout();
      this.$cookies.remove('api_token')
      this.modal = false
      this.$router.replace({name:'Home'})
    }
  },
  computed:{
  },
  mounted() {
    
  }
}
</script>
<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: transform .3s ease;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: scale(0);
}
.logout-icon{
  color: var(--theme2);
  font-size: 25px;
  position: relative;
  top: 4px;
  cursor: pointer;
}
</style>